import Vue from 'vue'
import vuetify from './plugins/vuetify'
import { VApp } from "vuetify/lib";
import axios from "axios";
import vueCustomElement from 'vue-custom-element'
import CCRESVisu from "./components/CCRESVisu"

// Vue.prototype.$prodPrefix = "http://localhost:8080/"

Vue.use(vueCustomElement);
Vue.use(axios);



Vue.customElement('ccres-visu', {
  vuetify: vuetify,
  components: { VApp, CCRESVisu },
  template: `<v-app id='app'><ccres-visu></ccres-visu></v-app>`
})




// vue-cli-service build --target lib --name CCRESVisu src/main.production.js